import Styled from 'styled-components';
import { Drawer } from 'antd';

const DrawerStyle = Styled(Drawer)`
.ant-drawer-body{
    background-color: #F3F4F6 !important;
  }
.ant-drawer-wrapper-body {
    background-color: #F3F4F6 !important;
}
`;

export { DrawerStyle };
